import React from "react";
import { CircularProgress } from "@mui/material";

import styles from "./JobSwmsFormV3SaveBar.module.css";

const SaveIcon = () => (
  <svg className={styles.actionSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path fill="currentColor" d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 237.3C544 220.3 537.3 204 525.3 192L448 114.7C436 102.7 419.7 96 402.7 96L160 96zM192 192C192 174.3 206.3 160 224 160L384 160C401.7 160 416 174.3 416 192L416 256C416 273.7 401.7 288 384 288L224 288C206.3 288 192 273.7 192 256L192 192zM320 352C355.3 352 384 380.7 384 416C384 451.3 355.3 480 320 480C284.7 480 256 451.3 256 416C256 380.7 284.7 352 320 352z" />
  </svg>
);

const PreviewIcon = () => (
  <svg className={styles.actionSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path fill="currentColor" d="M320 96C239.2 96 174.5 132.8 127.4 176.6C80.6 220.1 49.3 272 34.4 307.7C31.1 315.6 31.1 324.4 34.4 332.3C49.3 368 80.6 420 127.4 463.4C174.5 507.1 239.2 544 320 544C400.8 544 465.5 507.2 512.6 463.4C559.4 419.9 590.7 368 605.6 332.3C608.9 324.4 608.9 315.6 605.6 307.7C590.7 272 559.4 220 512.6 176.6C465.5 132.9 400.8 96 320 96zM176 320C176 240.5 240.5 176 320 176C399.5 176 464 240.5 464 320C464 399.5 399.5 464 320 464C240.5 464 176 399.5 176 320zM320 256C320 291.3 291.3 320 256 320C244.5 320 233.7 317 224.3 311.6C223.3 322.5 224.2 333.7 227.2 344.8C240.9 396 293.6 426.4 344.8 412.7C396 399 426.4 346.3 412.7 295.1C400.5 249.4 357.2 220.3 311.6 224.3C316.9 233.6 320 244.4 320 256z" />
  </svg>
);

const HistoryIcon = () => (
  <svg className={styles.actionSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path fill="currentColor" d="M176 168C189.3 168 200 157.3 200 144C200 130.7 189.3 120 176 120C162.7 120 152 130.7 152 144C152 157.3 162.7 168 176 168zM256 144C256 176.8 236.3 205 208 217.3L208 288L384 288C410.5 288 432 266.5 432 240L432 217.3C403.7 205 384 176.8 384 144C384 99.8 419.8 64 464 64C508.2 64 544 99.8 544 144C544 176.8 524.3 205 496 217.3L496 240C496 301.9 445.9 352 384 352L208 352L208 422.7C236.3 435 256 463.2 256 496C256 540.2 220.2 576 176 576C131.8 576 96 540.2 96 496C96 463.2 115.7 435 144 422.7L144 217.4C115.7 205 96 176.8 96 144C96 99.8 131.8 64 176 64C220.2 64 256 99.8 256 144zM488 144C488 130.7 477.3 120 464 120C450.7 120 440 130.7 440 144C440 157.3 450.7 168 464 168C477.3 168 488 157.3 488 144zM176 520C189.3 520 200 509.3 200 496C200 482.7 189.3 472 176 472C162.7 472 152 482.7 152 496C152 509.3 162.7 520 176 520z" />
  </svg>
);

const EditHistoryIcon = () => (
  <svg className={styles.actionSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
    <path fill="currentColor" d="M320 128C426 128 512 214 512 320C512 426 426 512 320 512C254.8 512 197.1 479.5 162.4 429.7C152.3 415.2 132.3 411.7 117.8 421.8C103.3 431.9 99.8 451.9 109.9 466.4C156.1 532.6 233 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C234.3 64 158.5 106.1 112 170.7L112 144C112 126.3 97.7 112 80 112C62.3 112 48 126.3 48 144L48 256C48 273.7 62.3 288 80 288L104.6 288C105.1 288 105.6 288 106.1 288L192.1 288C209.8 288 224.1 273.7 224.1 256C224.1 238.3 209.8 224 192.1 224L153.8 224C186.9 166.6 249 128 320 128zM344 216C344 202.7 333.3 192 320 192C306.7 192 296 202.7 296 216L296 320C296 326.4 298.5 332.5 303 337L375 409C384.4 418.4 399.6 418.4 408.9 409C418.2 399.6 418.3 384.4 408.9 375.1L343.9 310.1L343.9 216z" />
  </svg>
);

export default function JobSwmsFormV3SaveBar({ onSave, onDiscard, onCancel, onPreview, onVersionApprovalHistory, onEditHistory, editHistoryDisabled = false, isDirty = false, isSaving = false }) {
  return (
    <div className={styles.saveBar}>
      <div className={styles.actionGroup}>
        <button type="button" className={styles.primaryButton} onClick={onPreview}>
          <PreviewIcon />
          Preview WHS Pack
        </button>
        <button type="button" className={styles.outlinedButton} onClick={onVersionApprovalHistory}>
          <HistoryIcon />
          Version &amp; Approval History
        </button>
        <button type="button" className={styles.outlinedButton} disabled={editHistoryDisabled} onClick={onEditHistory}>
          <EditHistoryIcon />
          Edit History
        </button>
      </div>
      <div className={styles.actionGroup}>
        {isDirty ? <span className={styles.changeNotice}>Unsaved changes</span> : null}
        {isDirty ? (
          <button type="button" className={styles.discardButton} disabled={isSaving} onClick={onDiscard}>
            Discard Changes
          </button>
        ) : null}
        <button type="button" className={styles.cancelButton} onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className={styles.saveButton} disabled={!isDirty || isSaving} onClick={onSave}>
          {isSaving ? <CircularProgress size={14} /> : <SaveIcon />}
          Save Draft
        </button>
      </div>
    </div>
  );
}
